var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65.122 13.164 H 24.877 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 40.245 c 1.104 0 2 0.896 2 2 S 66.227 13.164 65.122 13.164 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88 30.453 H 2 c -1.104 0 -2 -0.896 -2 -2 v -9.082 C 0 13.743 4.579 9.164 10.207 9.164 h 6.55 c 1.104 0 2 0.896 2 2 s -0.896 2 -2 2 h -6.55 C 6.785 13.164 4 15.949 4 19.371 v 7.082 h 82 v -7.082 c 0 -3.422 -2.784 -6.207 -6.207 -6.207 h -6.55 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 6.55 C 85.421 9.164 90 13.743 90 19.371 v 9.082 C 90 29.557 89.104 30.453 88 30.453 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.932 89.102 H 10.207 C 4.579 89.102 0 84.522 0 78.895 V 28.453 c 0 -1.104 0.896 -2 2 -2 h 86 c 1.104 0 2 0.896 2 2 v 19.712 c 0 1.104 -0.896 2 -2 2 s -2 -0.896 -2 -2 V 30.453 H 4 v 48.442 c 0 3.423 2.785 6.207 6.207 6.207 h 37.725 c 1.104 0 2 0.896 2 2 S 49.036 89.102 47.932 89.102 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.255 53.637 h -4.876 c -2.577 0 -4.674 -2.097 -4.674 -4.674 v -4.875 c 0 -2.577 2.097 -4.674 4.674 -4.674 h 4.876 c 2.577 0 4.673 2.097 4.673 4.674 v 4.875 C 27.929 51.54 25.832 53.637 23.255 53.637 z M 18.379 43.414 c -0.372 0 -0.674 0.302 -0.674 0.674 v 4.875 c 0 0.371 0.302 0.674 0.674 0.674 h 4.876 c 0.371 0 0.673 -0.303 0.673 -0.674 v -4.875 c 0 -0.372 -0.302 -0.674 -0.673 -0.674 H 18.379 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.438 53.637 h -4.875 c -2.577 0 -4.674 -2.097 -4.674 -4.674 v -4.875 c 0 -2.577 2.097 -4.674 4.674 -4.674 h 4.875 c 2.577 0 4.674 2.097 4.674 4.674 v 4.875 C 52.111 51.54 50.015 53.637 47.438 53.637 z M 42.562 43.414 c -0.372 0 -0.674 0.302 -0.674 0.674 v 4.875 c 0 0.371 0.302 0.674 0.674 0.674 h 4.875 c 0.371 0 0.674 -0.303 0.674 -0.674 v -4.875 c 0 -0.372 -0.303 -0.674 -0.674 -0.674 H 42.562 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.255 74.665 h -4.876 c -2.577 0 -4.674 -2.097 -4.674 -4.674 v -4.875 c 0 -2.577 2.097 -4.674 4.674 -4.674 h 4.876 c 2.577 0 4.673 2.097 4.673 4.674 v 4.875 C 27.929 72.568 25.832 74.665 23.255 74.665 z M 18.379 64.442 c -0.372 0 -0.674 0.303 -0.674 0.674 v 4.875 c 0 0.371 0.302 0.674 0.674 0.674 h 4.876 c 0.371 0 0.673 -0.303 0.673 -0.674 v -4.875 c 0 -0.371 -0.302 -0.674 -0.673 -0.674 H 18.379 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.204 21.43 h -2.773 c -2.577 0 -4.674 -2.097 -4.674 -4.673 V 5.572 c 0 -2.577 2.097 -4.674 4.674 -4.674 h 2.773 c 2.577 0 4.674 2.097 4.674 4.674 v 11.185 C 26.877 19.333 24.781 21.43 22.204 21.43 z M 19.431 4.898 c -0.372 0 -0.674 0.302 -0.674 0.674 v 11.185 c 0 0.371 0.302 0.673 0.674 0.673 h 2.773 c 0.372 0 0.674 -0.302 0.674 -0.673 V 5.572 c 0 -0.372 -0.302 -0.674 -0.674 -0.674 H 19.431 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.569 21.43 h -2.773 c -2.577 0 -4.674 -2.097 -4.674 -4.673 V 5.572 c 0 -2.577 2.097 -4.674 4.674 -4.674 h 2.773 c 2.577 0 4.674 2.097 4.674 4.674 v 11.185 C 75.243 19.333 73.146 21.43 70.569 21.43 z M 67.796 4.898 c -0.371 0 -0.674 0.302 -0.674 0.674 v 11.185 c 0 0.371 0.303 0.673 0.674 0.673 h 2.773 c 0.371 0 0.674 -0.302 0.674 -0.673 V 5.572 c 0 -0.372 -0.303 -0.674 -0.674 -0.674 H 67.796 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.268 89.102 c -10.881 0 -19.732 -8.852 -19.732 -19.732 s 8.852 -19.732 19.732 -19.732 S 90 58.488 90 69.369 S 81.148 89.102 70.268 89.102 z M 70.268 53.637 c -8.675 0 -15.732 7.058 -15.732 15.732 s 7.058 15.732 15.732 15.732 S 86 78.044 86 69.369 S 78.942 53.637 70.268 53.637 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.202 77.956 c -0.495 0 -0.99 -0.183 -1.377 -0.55 l -6.935 -6.587 c -0.398 -0.378 -0.623 -0.902 -0.623 -1.45 v -9.641 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 8.782 l 6.312 5.995 c 0.802 0.761 0.834 2.026 0.073 2.827 C 78.259 77.747 77.73 77.956 77.202 77.956 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendar-white.09eeabfb4879f4b8164314c211587935.svg";
export { ForwardRef as ReactComponent };